// extracted by mini-css-extract-plugin
export default {"main":"styles_main__U3hlu","close":"styles_close__E6tCY"};